import React, { Component, Fragment } from 'react'
import Icon from 'antd/es/icon'

class PDF extends Component {
  render() {
    const { fileLinkList } = this.props
    const content = fileLinkList.map((fileLink) => (
      <a href={fileLink} target={'_blank'}>
        <Icon style={{ fontSize: 50, color: '#f00', paddingTop: '20px' }} type="file-pdf" />
      </a>
    ))
    return <Fragment>{content}</Fragment>
  }
}

export default PDF
